import _toConsumableArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { getCurrentTimestamp } from '../../../utils/TimestampManager';
import { BATTLES_STANDING_TYPE, BATTLES_STATES, BATTLES_STREAK_STATES } from '../constants/dictionary';
export var isCurrentGamePlayable = function isCurrentGamePlayable() {
  var currentGame = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (currentGame === null || currentGame === void 0 ? void 0 : currentGame.battlesGameStatus) === BATTLES_STATES.RUNNING && !(currentGame !== null && currentGame !== void 0 && currentGame.completedTimestamp);
};
export var checkAvailableGames = function checkAvailableGames() {
  var currentCycle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (currentCycle === null || currentCycle === void 0 ? void 0 : currentCycle.cycleGames) === (currentCycle === null || currentCycle === void 0 ? void 0 : currentCycle.gamesPlayed) && getCurrentTimestamp() < (currentCycle === null || currentCycle === void 0 ? void 0 : currentCycle.cycleEndTimestamp);
};
export var hasRewardToClaim = function hasRewardToClaim() {
  var _battlesData$currentS, _battlesData$currentG;
  var battlesData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (battlesData === null || battlesData === void 0 || (_battlesData$currentS = battlesData.currentStreak) === null || _battlesData$currentS === void 0 ? void 0 : _battlesData$currentS.grandReward) || (battlesData === null || battlesData === void 0 || (_battlesData$currentG = battlesData.currentGame) === null || _battlesData$currentG === void 0 ? void 0 : _battlesData$currentG.gameReward);
};
export var isBattleGameAlreadyClaimed = function isBattleGameAlreadyClaimed(currentGame) {
  if (!currentGame) return false;
  return currentGame.battlesGameStatus === BATTLES_STATES.FINISHED && currentGame.gameReward === null || currentGame.completedTimestamp !== null && currentGame.gameReward === null;
};
export var isBattleStreakAlreadyClaimed = function isBattleStreakAlreadyClaimed(currentStreak) {
  if (!currentStreak) return false;
  return (currentStreak === null || currentStreak === void 0 ? void 0 : currentStreak.streakStatus) === BATTLES_STREAK_STATES.DISPLAY;
};
export var pickNearbyStandings = function pickNearbyStandings(standings) {
  var window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  var sorted = _toConsumableArray(standings).sort(function (a, b) {
    return a.rank - b.rank;
  });
  var idx = sorted.findIndex(function (s) {
    return s.type === BATTLES_STANDING_TYPE.PLAYER;
  });
  if (idx === -1) return [];
  var start = Math.max(0, idx - (window - 1));
  var end = Math.min(start + window, sorted.length);
  return sorted.slice(start, end);
};
export var findFirstValidGameId = function findFirstValidGameId(gameIds, availableGames) {
  if (!Array.isArray(gameIds)) return null;
  var _iterator = _createForOfIteratorHelper(gameIds),
    _step;
  try {
    var _loop = function _loop() {
        var id = _step.value;
        if (availableGames.some(function (g) {
          return g.GAME_ID == id;
        })) return {
          v: id
        };
      },
      _ret;
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _ret = _loop();
      if (_ret) return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
};